import React from 'react'

import classNames from 'classnames'

import { Icon as V2Icon } from 'v2/ui'

import { Box } from 'ui/components/Box'
import { Icon, IconName } from 'ui/components/Icon/Icon'
import { Body } from 'ui/components/Text'
import { ColorScheme } from 'ui/styling/baseVariables/colors/colorPalette'
import { theme } from 'ui/styling/Theme.css'

import { useAppTemplateIconState } from './hooks/useAppTemplateIconState'
import { AppTemplate } from './types'

import { AppTemplateIconStyles } from './AppTemplateIcon.css'

const sizeMapping = {
    fa: {
        s: theme.icon.size.xs,
        m: theme.icon.size.s,
        l: theme.icon.size.m,
        xl: theme.icon.size.l,
        '2xl': theme.icon.size.xl,
    },
    initial: {
        s: 'm',
        m: 'l',
        l: 'xl',
        xl: 'xl',
        '2xl': 'xl',
    },
} as const

type AppTemplateIconProps = React.ComponentPropsWithoutRef<typeof Box> & {
    template: AppTemplate
    size?: 's' | 'm' | 'l' | 'xl' | '2xl'
}

export const AppTemplateIcon: React.FC<AppTemplateIconProps> = ({
    className,
    template,
    size = 's',
    ...props
}) => {
    const { icon, color_scheme: colorScheme } = template
    const { initial } = useAppTemplateIconState(template)

    const iconFamily = icon?.family || 'hugeicons'

    return (
        <Box
            noShrink
            {...props}
            className={classNames(
                className,
                AppTemplateIconStyles.styleFunction({
                    colorScheme: colorScheme as ColorScheme,
                    size,
                })
            )}
        >
            {(iconFamily === 'hugeicons' || iconFamily === 'lucide') && (
                <Icon
                    size={size}
                    family={iconFamily}
                    name={icon?.name as IconName<'hugeicons'>}
                    style={{ color: 'inherit' }}
                />
            )}
            {iconFamily === 'fa' && (
                <V2Icon icon={icon?.name} color="inherit" fontSize={sizeMapping.fa[size]} />
            )}
            {!icon && initial && (
                <Body size={sizeMapping.initial[size]} weight="bold" style={{ color: 'inherit' }}>
                    {initial}
                </Body>
            )}
        </Box>
    )
}
